import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/index.css';

const Header = ({ isAuthenticated, onLogout }) => {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const navRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (navRef.current && !navRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <header ref={navRef}>
            <nav className="coem-navbar">
                <a className="coem-navbar-brand" href="/">
                    <img src="icono.png" alt={t('brandIconAlt')} className="coemimage" />
                    COEMETERIUM
                </a>

                <button
                    className="coem-toggler"
                    type="button"
                    onClick={() => setIsOpen(!isOpen)}
                    aria-expanded={isOpen}
                    aria-label="Toggle navigation"
                >
                    <span className="coem-toggler-icon"></span>
                </button>

                <div className={`collapse coem-collapse ${isOpen ? 'show' : ''}`} id="coemNavbarContent" style={isOpen ? { display: 'block' } : {}}>
                    <ul className="coem-contact-list">
                        <li className="coem-contact-item">
                            <a className="coem-contact-link" href="tel:+34 91 345 55 98">
                                <span className="coem-icon-wrapper">
                                    <svg viewBox="0 0 24 24">
                                        <path d="M6.62 10.79c1.44 2.83 3.76 5.15 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.46.57 3.57.11.35.03.75-.25 1.02L6.62 10.79z" />
                                    </svg>
                                </span>
                                +34 91 345 55 98
                            </a>
                        </li>

                        <li className="coem-contact-item">
                            <a className="coem-contact-link" href="mailto:info@gtbi.net">
                                <span className="coem-icon-wrapper">
                                    <svg viewBox="0 0 24 24">
                                        <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
                                    </svg>
                                </span>
                                info@gtbi.net
                            </a>
                        </li>

                        {isAuthenticated && (
                            <li className="coem-contact-item">
                                <button
                                    className="coem-contact-link"
                                    onClick={onLogout}
                                    style={{ background: 'none', border: 'none', cursor: 'pointer' }}
                                >
                                    <span className="coem-icon-wrapper" style={{ backgroundColor: '#db08089c' }}>
                                        <svg className="logout-icon" viewBox="0 0 24 24" style={{ fill: 'white' }}>
                                            <path d="M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5c-1.11 0-2 .9-2 2v4h2V5h14v14H5v-4H3v4c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" />
                                        </svg>
                                    </span>
                                    {t('logout')}
                                </button>
                            </li>
                        )}

                    </ul>
                </div>
            </nav>
        </header>
    );
};

export default Header;
